"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const assert_1 = __importDefault(require("assert"));
const erc721_abi_1 = require("../../abi/erc721.abi");
/** example
 [
    [
        {
            chainId:'77',
            name: 'erc-721-owner-of',
            address: wallet.address,
            params: {
               tokenId:1234,
                address: '0xB81AFe27c103bcd42f4026CF719AF6D802928765'
            }
        }
    ]
 ]
 * @param web3Provider
 */
exports.strategy = (web3Provider) => (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { params, address } = strategy;
    assert_1.default(params.address !== undefined, 'erc20 address is required');
    assert_1.default(params.tokenId !== undefined, 'tokenId is required');
    const erc721Address = params.address;
    const erc721SmartContracts = new web3Provider.eth.Contract(erc721_abi_1.erc721ABI, erc721Address);
    const ownerOf = yield erc721SmartContracts.methods.ownerOf(params.tokenId).call().catch(() => null);
    const isAuthorized = address.toLowerCase() === ownerOf.toLowerCase();
    const code = isAuthorized ? 0 /* SUCCESS */ : 2 /* NOTOWNER */;
    const message = address === ownerOf ? `You are the owner of ${params.tokenId}` : `You are not the owner of ${params.tokenId}`;
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code
    };
});
//# sourceMappingURL=index.js.map